import React from 'react';
import type { AdMetadata } from '../../hooks/types';
import { isTemporaryRemoteMediaUrl } from '../../../../utils/failedImageCache';
import { sanitizeAdImageSrc, sanitizeUrl } from '../../../../utils/sanitize';

interface AdReferralCardProps {
    adMetadata: AdMetadata;
    /** Se o sender é 'me' para ajustar cores */
    isFromMe?: boolean;
}

export const AdReferralCard: React.FC<AdReferralCardProps> = ({ adMetadata, isFromMe = false }) => {
    const { imageUrl, headline, body, sourceUrl } = adMetadata;
    // sanitizeUrl bloqueia data: — thumbnails CTWA no DB são data:image;base64
    const safeImageUrl = imageUrl ? sanitizeAdImageSrc(imageUrl) : '';
    const safeSourceUrl = sourceUrl ? sanitizeUrl(sourceUrl) : '';
    const shouldRenderImage = !!safeImageUrl && (
        safeImageUrl.startsWith('data:image/') || !isTemporaryRemoteMediaUrl(safeImageUrl)
    );

    // Não renderiza se não tem conteúdo visual
    if (!shouldRenderImage && !headline && !body) return null;

    return (
        <div className={`border-b ${isFromMe ? 'border-white/10' : 'border-border'}`}>
            {/* Imagem do anúncio */}
            {shouldRenderImage && (
                <img
                    src={safeImageUrl}
                    alt={headline || 'Anúncio'}
                    className="w-full max-h-48 object-cover"
                    loading="lazy"
                    onError={(e) => {
                        (e.target as HTMLImageElement).style.display = 'none';
                    }}
                    referrerPolicy="no-referrer"
                />
            )}

            {/* Conteúdo textual */}
            <div className="px-4 py-2">
                {/* Badge Meta Ads */}
                <div className="flex items-center gap-1 mb-1">
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${isFromMe
                        ? 'bg-white/15 text-white/90'
                        : 'bg-primary/10 text-primary'
                        }`}>
                        ANÚNCIO META
                    </span>
                </div>

                {/* Título do anúncio */}
                {headline && (
                    <p className={`text-body-sm font-medium leading-snug ${isFromMe ? 'text-white' : 'text-default'
                        }`}>
                        {headline}
                    </p>
                )}

                {/* Descrição do anúncio */}
                {body && (
                    <p className={`text-body-sm mt-0.5 line-clamp-2 ${isFromMe ? 'text-white/70' : 'text-secondary'
                        }`}>
                        {body}
                    </p>
                )}

                {/* Link do anúncio */}
                {safeSourceUrl && (
                    <a
                        href={safeSourceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-body-sm mt-1 block truncate font-medium ${isFromMe ? 'text-white/60 hover:text-white/90' : 'text-primary hover:text-primary-dark'
                            }`}
                    >
                        {safeSourceUrl}
                    </a>
                )}
            </div>
        </div>
    );
};
